module.exports = __webpack_public_path__ + "static/original-tablet-82c7cf375787f75624bb5b9e9ae5d9b2.jpg";